import { render, staticRenderFns } from "./StatView.vue?vue&type=template&id=3d26b160"
import script from "./StatView.vue?vue&type=script&lang=js"
export * from "./StatView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports